/**
 * Applies the user's "reduced motion" preference on every client-side
 * navigation — not just when the settings page is open.
 *
 * Stored in localStorage under `diztree:reducedMotion` (set by
 * /settings). We write the `data-reduced-motion` attribute on <html> so
 * the global stylesheet (see app/assets/css/main.css) can kill
 * scroll-reveal + transform transitions site-wide.
 *
 * The OS-level `prefers-reduced-motion: reduce` is already respected by
 * the same stylesheet independently — this plugin only handles the
 * explicit user override.
 */
export default defineNuxtPlugin(() => {
    if (typeof window === 'undefined') return
    try {
        const on = window.localStorage.getItem('diztree:reducedMotion') === '1'
        if (on) document.documentElement.setAttribute('data-reduced-motion', '')
    } catch {
        // localStorage can throw in private mode or cross-origin frames —
        // the OS-level preference still covers those users.
    }
})
